import { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Redirect } from 'react-router-dom';
import { api_crud_route, api_crud_base, data_interface, endpoints } from './Config';
import Hosts from '../../../Hosts';
import { getTokenInfo } from '../../../UseToken';
import ReactQuill from 'react-quill';
import Loader from '../../Loader/Loader';
import Swal from 'sweetalert2'
import { language } from './Language';
import {
	reqGET,
	reqPOST,
	reqDELETE,
	reqPUT,
	reqFILE,
	handle_compressed_image_upload,
} from '../../../Utils';
import { icon } from '../../WEBContent/Icon';
import { color } from '../../WEBContent/Color';
import { use } from 'react';

export default function Regist(props) {
	const [, set_dados] = useState(null);
	const dados = useRef(null);
	const [lang, set_lang] = useState('pt');
	const [lang_id, set_lang_id] = useState('1');

	const [isloading, setLoading] = useState(true);
	const [refresh, setRefresh] = useState(0);
	const [isRedirect, setRedirect] = useState(false);
	const [show_delete_button, set_show_delete_button] = useState(false);
	const [is_edit, set_is_edit] = useState(false)

	const [files_image, set_files_image] = useState([]);
	const [image_base64, set_image_base64] = useState([]);
	const [img_loader, set_img_loader] = useState([])

	const entidades = useRef(null);
	const [allResponsaveis, setAllResponsaveis] = useState([]);
	const [originalResponsaveis, setOriginalResponsaveis] = useState([]);

	const [name, setName] = useState(null);
	const [userId, setUserId] = useState(null);
	const [profile, setProfile] = useState(null);
	const [message, setMessage] = useState("");

	const fetch_id_info = async (id_serch) => {
		return await reqGET(`${api_crud_route}/${getTokenInfo().companycode}/${id_serch}`)
			.then(res => {
				set_dados(dados.current = res.data[0]);
			})
			.catch(error => console.log(error)/*TODO: GO TO FAIL FETCH*/)
	}

	const clean_data = () => {
		// DEEP COPY OF data_interface 
		set_dados(dados.current = JSON.parse(JSON.stringify(data_interface)))
		set_dados(dados.current.info.companycode = getTokenInfo().companycode)
		//console.log(dados.current)
	}

	useEffect(() => {
		const storedData = localStorage.getItem('token');
		const data = JSON.parse(storedData);
		if (storedData) {
			const data = JSON.parse(storedData);
			if (data.user_info) {
				if (data.user_info.user_info) {

				} else {
					setProfile(data.user_info.profile);
					setName(data.user_info.name);
					setUserId(data.user_info.id);
					setMessage(data.user_info.message);

					console.log('userId', userId)
				}
			} else {
				console.log('User info nÃ£o encontrado no localStorage');
			}
		} else {
			console.log('Dados nÃ£o encontrados no localStorage');
		}
	}, []);

	useEffect(() => {
		clean_data();
		set_lang(localStorage.getItem('lang'))

		try {
			let test = props.location.state.operation;

			if (test === 'edit') {
				//set_disabled(true)

				set_is_edit(true)

				set_show_delete_button(true)

				fetch_id_info(props.location.state.item['id']).then(() => {
					setLoading(false)
				})
				return
			}
			else {

				clean_data()

				setLoading(false);

				setRedirect(false);

			}

		} catch {
			clean_data()

			setLoading(false);

			setRedirect(false);
			return
		}

		return () => {
			clean_data()
		}

	}, [props])

	useEffect(() => {
		if (dados?.current?.info?.responsaveis) {
			setOriginalResponsaveis([...dados.current.info.responsaveis]);
		}
	}, [dados?.current?.info]);

	const getNewMembers = () => {
		const current = dados.current.info.responsaveis || [];
		const originals = originalResponsaveis || [];

		return current.filter(
			member => !originals.some(orig => orig.id === member.id)
		);
	};

	const getRemovedMembers = () => {
		const current = dados.current.info.responsaveis || [];
		const originals = originalResponsaveis || [];

		return originals.filter(
			member => !current.some(cur => cur.id === member.id)
		);
	};

	function apagar() {
		Swal.fire({
			title: language[lang].delete_title,
			text: language[lang].delete_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].delete_confirm,
			cancelButtonText: language[lang].delete_cancel
		})
			.then((result) => {
				if (result.isConfirmed) {
					reqDELETE(api_crud_route, { id: dados.current.id })
						.then(() => {
							props.history.push(endpoints.list);
						})
						.catch(error => console.log(error))
				}
			})
			.catch((erro) => {
				console.log(erro)
			})

	};

	function hex2rgb(value) {
		var hex_color = value
		var pattern_color = "^#([A-Fa-f0-9]{6})$";
		if (hex_color.match(pattern_color)) {
			var hex_color_aux = hex_color.replace("#", "")
				, r = parseInt(hex_color_aux.substring(0, 2), 16)
				, g = parseInt(hex_color_aux.substring(2, 4), 16)
				, b = parseInt(hex_color_aux.substring(4, 6), 16);
			return '' + r + ',' + g + ',' + b + '';
		}
		else {
			alert('Error Color Format');
		}
	}

	const handle_change_info_color = (e) => {
		const { name, value } = e.target;

		if (dados.current.info.color === undefined) {
			dados.current.info.color = { primary: '', primary_rgb: '', secondary: '' }
		}

		let color_rgb = hex2rgb(value)

		if (name === 'primary') {
			dados.current.info.color['primary_rgb'] = color_rgb
		}

		dados.current.info.color[name] = value

		set_dados(dados.current.info)
		setRefresh(refresh + 1)
		console.log('«««««««««««««««««««««««')
		console.log('Dados Current:' + JSON.stringify(dados))
	}

	const handleSubmit = async (e) => {
		e.preventDefault();
		const currentDateTime = new Date().toISOString();

		if (!dados.current.info.submissoes) {
			dados.current.info.submissoes = [];
		}

		dados.current.info.submissoes.push({
			userId,
			name,
			profile,
			timestamp: currentDateTime,
			message: 'Atualização'
		});

		/*

		const newMembers = getNewMembers();
		const removedMembers = getRemovedMembers();

		if (newMembers.length || removedMembers.length) {
			alert(
				`Changes detected:\n` +
				(newMembers.length ? `Foi Adicionado: ${newMembers.map(m => m.name).join(', ')}\n` : '') +
				(removedMembers.length ? `Foi Removido: ${removedMembers.map(m => m.name).join(', ')}` : '')
			);

			console.log('🆕 New members:', newMembers);
			console.log('❌ Removed members:', removedMembers);
		}
		*/

		try {

			if (is_edit === true) {

				Swal.fire({
					title: language[lang].edit_title,
					text: language[lang].edit_text,
					icon: 'question',
					showCancelButton: true,
					confirmButtonColor: '#0095e8',
					cancelButtonColor: '#d9214e',
					confirmButtonText: language[lang].edit_confirm,
					cancelButtonText: language[lang].edit_cancel

				}).then(async (result) => {
					if (result.isConfirmed) {
						try {
							await reqPUT(api_crud_route, dados.current);

							files_image.forEach(async (el_image) => {
								if (el_image !== null) {
									if (el_image.files.length > 0) {
										await uploadFilesImage(el_image.files, el_image.order, 'image', el_image.langid, el_image.lang)
									}
								}
							})
							set_files_image([])
							set_image_base64([])

							// window.location.reload();
							//props.history.push(endpoints.list);

						} catch (error) {
							Swal.fire(language[lang].edit_error, '', 'info');
						}
					}
				});
			} else {

				Swal.fire({
					title: language[lang].insert_title,
					text: language[lang].insert_text,
					icon: 'question',
					showCancelButton: true,
					confirmButtonColor: '#0095e8',
					cancelButtonColor: '#d9214e',
					confirmButtonText: language[lang].insert_confirm,
					cancelButtonText: language[lang].insert_cancel

				}).then(async (result) => {
					if (result.isConfirmed) {
						try {
							await reqPOST(api_crud_route, dados.current);
							props.history.push(endpoints.list);

							files_image.forEach(async (el_image) => {
								if (el_image !== null) {
									if (el_image.files.length > 0) {
										await uploadFilesImage(el_image.files, el_image.order, 'image', el_image.langid, el_image.lang)
									}
								}
							})
							set_files_image([])
							set_image_base64([])

							window.location.reload();

						} catch (error) {
							Swal.fire(language[lang].insert_error, '', 'info');
						}
					}
				});
			}

		} catch (error) {
			console.error("Erro ao verificar a existência do departamento:", error);
			Swal.fire({
				title: 'Erro',
				text: 'Ocorreu um erro ao verificar a existência do departamento.',
				icon: 'error',
				confirmButtonText: 'OK',
			});
		}
	};

	const onChangeHandlerFilesImage = async (e) => {
		const { files, dataset } = e.target;
		const { order, langid, lang } = dataset

		let storedFiles = [];
		let filesArray = Array.prototype.slice.call(files);
		let files_img_aux = image_base64

		let k = 0
		// filesArray.forEach(async (v, k) => {
		for await (let v of filesArray) {
			if ((v.type.includes('image/')) && (v.size < 10485760)) {

				console.log('1')
				await handle_compressed_image_upload(v, (valor) => storedFiles.push(valor))
				//storedFiles.push(v);

				console.log('2')
				await convertBase64(v)
					.then((base64) => {
						// console.log('base64', base64)

						if (files_img_aux[order] === undefined)
							files_img_aux[order] = []
						if (files_img_aux[order][langid] === undefined)
							files_img_aux[order][langid] = []

						files_img_aux[order][langid].push({ id: '1', langid: langid, name: v.name.split('.')[0] + '.webp', link: base64 })
						set_image_base64(files_img_aux)
						setRefresh(refresh + Math.random())
					})


				console.log('3')

				if (filesArray.length === (k + 1)) {
					//set_dados(dados.current,)
					//setRefresh(refresh + 1)
					setRefresh(refresh + parseInt(v.size) + k)
				}


				console.log('4')

			}
			else {
				Swal.fire(language[lang].upload_image_error + v.name, '', 'info')
			}

			k++
		}
		// });

		console.log('storedFiles', storedFiles)


		let files_aux = files_image
		files_aux.push({ files: storedFiles, order: order, lang: lang, langid: langid })
		set_files_image(files_aux)

	}

	const convertBase64 = async (file) => {
		return new Promise((resolve, reject) => {
			const fileReader = new FileReader();
			fileReader.readAsDataURL(file);

			fileReader.onload = () => {
				resolve(fileReader.result);
			};

			fileReader.onerror = (error) => {
				reject(error);
			};
		});
	};

	const handleFileRemove = () => {
		set_dados(prevDados => ({
			...prevDados,
			info: {
				...prevDados.info,
				foto: []
			}
		}));
	};

	const uploadFilesImage = async (files, order, type, langid, lang) => {

		let aux = []
		files.forEach(async (element) => {
			if (element.type.includes('image/')) {
				aux.push(element)

				let y = img_loader
				y.push('img')
				set_img_loader(y)

				await uploadFile(element, order, type, langid, lang)
					.then(() => {
						//console.log('success')
					})
			}
			else {
				Swal.fire('Formato do ficheiro incorrecto!', '', 'info')
			}
		})
	}

	const uploadFile = async (file, order, type, langid, lang) => {
		const formData = new FormData()
		formData.append('files', file)
		formData.append('id', dados.current.id)
		formData.append('file_name', file.name)
		formData.append('type', 'content')
		formData.append('companycode', dados.current.info.companycode)
		formData.append('uniqid', dados.current.info.uniqid)
		formData.append('folder', Hosts.APP_REPO_FOLDER + 'upload/content/');

		console.log('api_crud_base', api_crud_base)
		console.log('formData', formData)

		return await reqFILE(`${api_crud_base}/multimedia/file`, formData)
			.then((res) => {
				var today_file = new Date()

				let i = Date.now()

				let x = {
					id: i,
					info: {
						companycode: getTokenInfo().companycode,
						type: res.data.mimetype,
						link: res.data.path + '/' + res.data.name,
						size: res.data.size,
						date: today_file
					},
					content: {
						name: file.name,
						description: '',
						lang: []
					}
				}

				dados.current.info.foto = [
					{
						name: file.name,
						type: file.type,
						size: file.size,
						path: res.data.path,
						source_name: res.data.name,
						link: res.data.path + '' + res.data.name,
					},
				];

				reqPUT(api_crud_route, dados.current)
					.then(() => {
						//props.history.push(endpoints.list) 
					})
					.catch(() => Swal.fire(language[lang].edit_error, '', 'info'))

				reqPOST(`${api_crud_base}/multimedia`, x)
					.then(() => {

						let y2 = img_loader
						y2.pop()
						set_img_loader(y2)
						setRefresh(i)

					})
					.catch(() => Swal.fire('Problema ao inserir Registo!', '', 'info'))

				return true

			})
			.catch(erro => console.log('Erro POST File: ' + erro))
	}

	const handle_change_info = (e) => {
		const { name, value } = e.target;

		let updatedData = { ...dados.current };

		updatedData.info[name] = value;

		set_dados(updatedData);
	};

	useEffect(() => {
		const fetch_entidades = async () => {
			try {
				let res_entidade = await reqGET(
					`${Hosts.SIMCore_API}/entities/list/${getTokenInfo().companycode}/*`
				);

				let result = [];
				if (res_entidade.data !== undefined) {
					result = res_entidade.data.filter(el => el.entity_type === "1");
				}

				// guarda entidades no ref + state
				set_dados(entidades.current = result);
				console.log("Entidades", entidades.current);

				setAllResponsaveis(result);
				console.log("Responsáveis (Entidades)", result);

			} catch (error) {
				console.error("Erro ao buscar as Entidades:", error);
				setAllResponsaveis([]);
			}
		};

		fetch_entidades();
	}, []);

	return isloading ?

		<Loader />

		:

		isRedirect
			?
			<Redirect to={endpoints.list} replace />
			:
			<main id="departamento-regist">
				<div className={`dash-cards header`}>
					<div >
						<h2 className="dash-title" >{language[lang].category}</h2>
						<p className='mb-3' >{language[lang].category} / {dados.current.id !== '' ? language[lang].category_edit : language[lang].category_edit}</p>
					</div>

					<div className={`dash-cards body`} >
						<div className="card mb-5 mb-xl-10 ">
							<div>
								<form id="form" onSubmit={handleSubmit}>
									<div className="card-body">
										<div className="row mb-6">
											{/* Grupo */}
											<div className="col-md-6 mt-1 my-3">
												<label className="fs-6 fw-bold mb-2">
													{language[lang].group_name}
												</label>
												<input
													type="text"
													name="name"
													value={dados.current.info.name}
													className="form-control rounded-0"
													placeholder={language[lang].name_placeholder}
													onChange={handle_change_info}
													required
												/>
											</div>

											<div className="col-md-2 ms-3 mb-3">
												<label className="fs-6 fw-bold mb-2">{language[lang].color_primary}</label>
												<input
													type="color"
													name="primary"
													className="form-control form-control-color rounded-0"
													value={dados.current.info?.color?.primary || "#000000"}
													onChange={handle_change_info_color}
												/>
											</div>

											<div className="col-md-2 mb-3">
												<label className="fs-6 fw-bold mb-2">{language[lang].color_secondary}</label>
												<input
													type="color"
													name="secondary"
													className="form-control form-control-color rounded-0"
													value={dados.current.info?.color?.secondary || "#FFFFFF"}
													onChange={handle_change_info_color}
												/>
											</div>

										</div>

										<br />

										<div style={{ display: 'flex', gap: '10px', width: '100%' }}>
											{/* Description */}
											<div style={{ flex: 1 }}>
												<span className="flex-2 assec-mb-15">
													<label className="fs-6 fw-bold mb-2">
														{language[lang].description}
													</label>
													<textarea
														name="description"
														value={dados.current.info.description}
														className="form-control rounded-0"
														rows="4"
														onChange={handle_change_info}
													/>
												</span>
											</div>

											{/* Image Upload */}
											<div className="col-md-4 p-4 bg-white shadow-sm rounded">
												<div className="mt-4">
													<ul className="list-unstyled d-flex flex-wrap gap-3 mt-3 justify-content-center">
														{dados?.current?.info?.foto?.length > 0 ? (
															dados.current.info.foto.map((file, index) => {
																const imageURL = file.link || URL.createObjectURL(file);
																return (
																	<li key={index} className="d-flex flex-column align-items-center">
																		<img
																			src={imageURL}
																			className="img-fluid rounded"
																			alt="Uploaded"
																			style={{ width: "120px", height: "120px", objectFit: "cover" }}
																		/>
																		<small className="mt-2 text-muted">{file.name || 'Imagem'}</small>
																	</li>
																);
															})
														) : (
															<li className="text-muted">{language[lang].noPhoto}</li>
														)}
													</ul>

													<div className="d-flex justify-content-center mt-4 gap-2">
														<input
															type="file"
															accept="image/*"
															onChange={onChangeHandlerFilesImage}
															data-order={1}
															data-langid={lang_id}
															data-lang={lang}
															data-type={'image'}
															className="dropzone-select btn btn-sm btn-primary me-2 d-none"
															id="photo-upload"
														/>

														<label htmlFor="photo-upload" className="btn btn-outline-primary btn-sm">
															{language[lang].photo}
														</label>

														{dados?.current?.info?.foto?.length > 0 && (
															<button
																type="button"
																onClick={handleFileRemove}
																style={{
																	marginLeft: "5px",
																	backgroundColor: color.corVermelha.rgb,
																	color: "#FFF",
																	border: "none",
																	borderRadius: "5px",
																	cursor: "pointer",
																	padding: "3px 10px",
																}}
															>
																X
															</button>
														)}
													</div>
												</div>
											</div>
										</div>

										<br />

										{/* Membros do Grupo */}
										{console.log('originalResponsaveis', originalResponsaveis)}
										<div>
											<label className="fs-6 fw-bold mb-2">
												{language[lang].membros} {language[lang].group}
											</label>
											<div className="d-flex justify-content-center">
												<table className="table my-4 table-hover ms-4">
													<thead>
														<tr className="tr-line">
															<th style={{ width: "30%" }}><strong>{language[lang].name}</strong></th>
															<th style={{ width: "30%" }}><strong>{language[lang].id}</strong></th>
															<th style={{ width: "30%" }}><strong>{language[lang].admin}</strong></th>
														</tr>
													</thead>
													<tbody>
														{dados.current.info.responsaveis.map(responsavel => (
															<tr key={responsavel.id} /*onClick={() => handleRowClick(responsavel.id)} style={{ cursor: 'pointer' }}*/>
																<td>{responsavel.name}</td>
																<td>{responsavel.id}</td>
																<td>
																	<div className="form-check form-switch">
																		<input
																			className="form-check-input"
																			type="checkbox"
																			checked={responsavel.AdminGroup || false}
																			disabled={
																				!(
																					getTokenInfo().profile === 'Administrador' ||
																					(dados.current.info.responsaveis[0]?.id === userId &&
																						dados.current.info.responsaveis[0]?.AdminGroup === true)
																				)
																			}
																			onChange={(e) => {
																				const responsaveis = [...dados.current.info.responsaveis];
																				const index = responsaveis.findIndex(r => r.id === responsavel.id);
																				if (index !== -1) {
																					responsaveis[index].AdminGroup = e.target.checked;
																					dados.current.info.responsaveis = responsaveis;
																					setAllResponsaveis([...allResponsaveis]);
																				}
																			}}
																		/>
																	</div>
																</td>

																{(
																	getTokenInfo().profile === 'Administrador' ||
																	(
																		dados.current.info.responsaveis[0]?.id === userId &&
																		dados.current.info.responsaveis[0]?.AdminGroup === true
																	)
																) && (
																		<td>
																			<button
																				className="btn btn-sm btn-outline-danger"
																				onClick={() => {
																					dados.current.info.responsaveis = dados.current.info.responsaveis.filter(
																						r => r.id !== responsavel.id
																					);
																					setAllResponsaveis([...allResponsaveis]);
																				}}
																			>
																				{language[lang].remove}
																			</button>
																		</td>
																	)}
																<td>
																	<Link
																		id={'c_' + responsavel.id}
																		className="d-none"
																		to={{
																			pathname: 'entidade_view',
																			state: { item: responsavel, operation: 'view' },
																		}}
																		replace
																	>
																		<i className="bi bi-eye"></i>
																	</Link>
																</td>
															</tr>
														))}
													</tbody>
												</table>
											</div>

											< br />

											{/* Selecionar Responsáveis */}
											<div className="col-md-12 mt-2 my-3">
												<label className="fs-6 fw-bold mb-2">
													{language[lang].add_membros}
												</label>

												<div className="d-flex justify-content-center">
													<table className="table my-4 table-hover ms-4">
														<thead>
															<tr className="tr-line">
																<th style={{ width: "30%" }}><strong>{language[lang].name}</strong></th>
																<th style={{ width: "40%" }}><strong>{language[lang].departament}</strong></th>
															</tr>
														</thead>
														<tbody>
															{allResponsaveis.map(user => {
																const departamento = user.departamento?.[0]?.name || 'Sem departamento';
																const isChecked = dados.current.info.responsaveis?.some(r => r.id === user.id);

																return (
																	<tr key={user.id} /*onClick={() => handleRowClick(user.id)} style={{ cursor: 'pointer' }}*/>
																		<td>{user.name}</td>
																		<td>{departamento}</td>

																		{(
																			getTokenInfo().profile === 'Administrador' ||
																			(
																				dados.current.info.responsaveis[0]?.id === userId &&
																				dados.current.info.responsaveis[0]?.AdminGroup === true
																			)
																		) && (
																				<td>
																					<input
																						type="checkbox"
																						checked={isChecked}
																						onChange={() => {
																							const current = [...(dados.current.info.responsaveis || [])];

																							if (!isChecked) {
																								current.push({
																									id: user.id,
																									name: user.name,
																									departamento: departamento,
																									AdminGroup: false
																								});
																							} else {
																								const index = current.findIndex(r => r.id === user.id);
																								if (index !== -1) current.splice(index, 1);
																							}

																							dados.current.info.responsaveis = current;
																							setAllResponsaveis([...allResponsaveis]);
																						}}
																					/>
																				</td>
																			)}

																		<td>
																			<Link
																				id={'c_' + user.id}
																				className="d-none"
																				to={{
																					pathname: 'entidade_view',
																					state: { item: user, operation: 'view' },
																				}}
																				replace
																			>
																				<i className="bi bi-eye"></i>
																			</Link>
																		</td>
																	</tr>
																);
															})}
														</tbody>
													</table>
												</div>
											</div>
										</div>
									</div>
								</form>
							</div>
						</div>
					</div>
				</div>

				<div className={'dash-cards footer'}>
					<nav className="navbar bottom-navbar navbar-light">
						<div className="navbar-footer">
							<ul className="navbar-nav float-left"></ul>
							<ul className="navbar-nav float-right">
								<li className="nav-item">
									<Link className="nav-link btn-cancel" to={{ pathname: endpoints.list }}  >
										<i className="bi bi-chevron-left me-2"></i>
										<span>{language[lang].back}</span>
									</Link>
								</li>
								<li className={"nav-item " + show_delete_button}>
									<button onClick={() => apagar(dados.current.id)} className="nav-link btn-delete">
										<i className="bi bi-trash3 me-2"></i>
										<span>{language[lang].delete}</span>
									</button>
								</li>
								<li className="nav-item">
									<button type="submit" form="form" className="nav-link">
										<i className="bi bi-floppy me-2"></i>
										<span>{language[lang].save}</span>
									</button>
								</li>
							</ul>
						</div>
					</nav>
				</div>
			</main>
}